module.exports = __webpack_public_path__ + "img/stay_turned.55219443.svg";